import React, {useState, useEffect} from 'react';
import { useBlynkApi } from '../hooks/useBlynkApi';
import './TemperatureSelector.css';
import { useBackEndWebHooks } from '../hooks/useBackEndWebHooks';

/// Generates square component with a minus sign to the left, a plus sign to the right and a number in the middle. The number is the actual temperature value. The minus and plus signs are used to decrease and increase the temperature value respectively. Upon change, the resulting value is posted to blynkApi
const TemperatureSelector = ({onTemperatureChange}) => {
    const [temperature, setTemperature] = useState(0);
    const [tempInput, setTempInput] = useState(0); //we need a secondary state to properly trigger the call onblur
    const {getDesiredTemperature, updateDesiredTemperature} = useBlynkApi();
    const temperatureStep = 0.5;
    const {callTemperatureUpdatedWebhook} = useBackEndWebHooks();

    const updateTemperature = async (newTemperature) => {
        //update the temperature in the state and make the api calls here
        setTemperature(newTemperature);
        await Promise.all([
            updateDesiredTemperature(newTemperature),
            callTemperatureUpdatedWebhook(newTemperature)
        ]);

        onTemperatureChange(); // Call the callback function passed down from the parent
    };

    const increaseTemperature = () => {
        const newTemp = temperature + temperatureStep
        updateTemperature(newTemp);
        setTempInput(newTemp);
    };

    const decreaseTemperature = () => {
        const newTemp = temperature - temperatureStep
        updateTemperature(newTemp);
        setTempInput(newTemp);
    };

    const handleTemperatureChange = (event) => {
        const temp = parseFloat(event.target.value);
        setTempInput(temp);  //  update temporary input
    };

    const handleBlur = () => {
        updateTemperature(tempInput);  // do the actual call on blur, but using temp value
    };

    useEffect(() => {
        const fetchDesiredTemperature = async () => {
            const response = await getDesiredTemperature();
            setTemperature(response);
            setTempInput(response);  //  initialize temporary input
        };

        fetchDesiredTemperature();
    }, [getDesiredTemperature]);

    return (
        <div className='temperature-selector px-3'>
            <div className='row'>
                <div className='col-2 p-0'>
                    <button onClick={decreaseTemperature}>-</button>
                </div>
                <div className='col-8 p-0'>
                    <input 
                        className='temperature-selector-input'
                        type='number'
                        step={temperatureStep}
                        value={tempInput}  // use temporary input for value
                        onChange={handleTemperatureChange}
                        onBlur={handleBlur}
                    />
                </div>
                <div className='col-2 p-0'>
                    <button onClick={increaseTemperature}>+</button>
                </div>
            </div>
        </div>
    );
};

export default TemperatureSelector;